export default __webpack_public_path__ + "static/media/ICICI-Lombard.9677506e.jpg";